// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"99":"a84cc6f8","893":"b07e60b8","922":"b07e60b8"}[chunkId] + ".css";
};